
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/policy/[slug]",
      function () {
        return require("private-next-pages/en/policy/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/policy/[slug]"])
      });
    }
  